// extracted by mini-css-extract-plugin
module.exports = {"container":"FAQPageSections_container__2V7TK","sectionCollapse":"FAQPageSections_sectionCollapse__3aXUq","arrowButton":"FAQPageSections_arrowButton__3r0Q8"};